import { Stage } from 'konva/lib/Stage';
import { getWindowKonvaObject } from './konva/getWindowKonvaObject';

export const getElementSize = (shapeId: string, stageObject?: Stage) => {
  const stage = stageObject || getWindowKonvaObject().stages[0];
  if (!stage || !shapeId) return null;

  const stageBox = stage.container().getBoundingClientRect();
  const shapeNode = stage.findOne(`#shape-${shapeId}`);
  if (!shapeNode) return null;

  const shapeBox = shapeNode.getSize();
  const shapePosition = shapeNode.getPosition();
  return {
    width: shapeBox.width,
    height: shapeBox.height,
    x: shapePosition.x,
    y: shapePosition.y
  };
};
